import React from 'react'
import Slider, { Settings } from 'react-slick'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

interface slickGalleryProps {
  galleryItems: Array<JSX.Element>
  settings: Settings
  classes?: string
}

export const DATA_TEST_SLICK = 'test-id-gallery'

const SlickGallery = ({ classes = '', galleryItems = [], settings }: slickGalleryProps) => {
  return (
    <div className={classes} data-testid={DATA_TEST_SLICK}>
      <Slider {...settings}>
        {galleryItems.map((item, i) => (
          <div className='h-full' key={`${i * 2}`}>
            {item}
          </div>
        ))}
      </Slider>
      <style global jsx>{`
        .slick-dots li {
          padding: 0;
          width: 15px;
          height: 15px;
          background: var(--color-text-default);
          border-radius: 50%;
          transition: 0.3s all;
        }
        .slick-dots li.slick-active {
          width: 50px;
          background: var(--color-icon-muted);
          border-radius: 100px;
        }
        .slick-dots li button:before {
          display: none;
        }
        .slick-dots li button {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        .slick-track {
          display: flex !important;
        }
        .slick-slide {
          height: inherit !important;
        }
        .slick-slide > div {
          height: 100% !important;
        }
      `}</style>
    </div>
  )
}

export default SlickGallery
